import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-aug-gray-dark text-aug-gray-light py-3xl" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-2xl mb-2xl">
          <div>
            <div className="w-12 h-12 bg-aug-blue rounded-lg flex items-center justify-center mb-4">
              <span className="text-white font-bold text-xl">AUG</span>
            </div>
            <p className="text-sm leading-relaxed">
              Transformando negócios através de tecnologia, inteligência artificial e soluções inovadoras.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Início</Link>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Sobre</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Blog</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-white transition-colors">Política de Privacidade</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Termos de Uso</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Redes Sociais</h4>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-white transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors" aria-label="Email">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-aug-gray-medium pt-lg">
          <p className="text-sm text-center">
            © {new Date().getFullYear()} Agro Urban Global. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;